import { render, staticRenderFns } from "./SelectCultureComponent.vue?vue&type=template&id=9012f0e2"
import script from "./SelectCultureComponent.vue?vue&type=script&lang=js"
export * from "./SelectCultureComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports